import types from './types';

const clearSearch = () => ({
	type: types.CLEAR_SEARCH
});

const clearPopupSearch = () => ({
	type: types.CLEAR_POPUP_SEARCH
});

const updateSearch = info => ({
	type: types.UPDATE_SEARCH,
	payload: info
});

const updatePopupSearch = info => ({
	type: types.UPDATE_POPUP_SEARCH,
	payload: info
});

const updateFilter = (filter) => ({
	type: types.UPDATE_FILTER,
	payload: filter
});

const clearFilter = () => ({
	type: types.CLEAR_FILTER
});


const updateCheckinFilter = (filter) => ({
	type: types.UPDATE_CHECKIN_FILTER,
	payload: filter
});

const clearCheckinFilter = () => ({
	type: types.CLEAR_CHECKIN_FILTER
});

const clearCheckinRosterFilter = () => ({
	type: types.CLEAR_CHECKIN_ROSTER_FILTER
});


const updateStudents = (students) => ({
	type: types.UPDATE_STUDENTS,
	payload: students
});

const updateCheckinStudents = (students) => ({
	type: types.UPDATE_STUDENTS,
	payload: students
});

const updatePlaceholder = (placeholder) => ({
	type: types.UPDATE_PLACEHOLDER,
	payload: placeholder
});

const clearPlaceholder = () => ({
	type: types.CLEAR_PLACEHOLDER
});

const updateRosterFilter = (data) => ({
	type: types.UPDATE_ROSTER_FILTER,
	payload: data
});


const updateCheckinRosterFilter = (data) => ({
	type: types.UPDATE_CHECKIN_ROSTER_FILTER,
	payload: data
});



export default {
	clearSearch,
	clearPopupSearch,
	updateSearch,
	updatePopupSearch,
	updateFilter,
	updateCheckinFilter,
	clearCheckinFilter,
	clearCheckinRosterFilter,
	updateCheckinStudents,
	clearFilter,
	updateStudents,
	updatePlaceholder,
	clearPlaceholder,
	updateRosterFilter,
	updateCheckinRosterFilter
};
